import { useState, useEffect, useRef } from "react";

const GOLD    = "#B8952A";
const GOLD_LT = "#D4A93A";
const GOLD_BG = "#FBF6EC";
const WHITE   = "#FFFFFF";
const LIGHT   = "#F7F8FA";
const LIGHT2  = "#EFF1F5";
const DARK    = "#12141A";
const MUTED   = "#6B7280";
const BORDER  = "#E5E7EB";
const NAVY    = "#1A3C6E";
const HERO_VIDEO = "/vide.mp4";
const ABOUT_BG_IMAGE = "/img.jpg";
const BRAND_LOGO_IMAGE = "/logo-launch-leap.png";
const VIDEO_LIBRARY = [
  {
    title:"How to Open a Forex Broker Account in Dubai from India | Dubai Visa & License Process | Hitesh Yadav",
    category:"Forex Account",
    duration:"YouTube",
    src:"https://www.youtube.com/embed/SirbvjJm8oU?rel=0&modestbranding=1",
    summary:"Channel: Hitesh Yadav",
  },
  {
    title:"Which visa is best for trader | How to get Dubai Visa | Start Forex trading from Dubai |Hitesh Yadav",
    category:"Visa Guide",
    duration:"YouTube",
    src:"https://www.youtube.com/embed/yCQP5cI8PVU?rel=0&modestbranding=1",
    summary:"Channel: Hitesh Yadav",
  },
  {
    title:"How to start Crypto & Forex Trading Business in Dubai | Zero Tax | License Cost | Hitesh Yadav",
    category:"Crypto & Forex",
    duration:"YouTube",
    src:"https://www.youtube.com/embed/Ey3e6rROX7c?rel=0&modestbranding=1",
    summary:"Channel: Hitesh Yadav",
  },
  {
    title:"Dubai Freelance Visa Cost | Scam in Dubai | Forex Trading in Dubai | Freezone Dubai License Cost",
    category:"Freelance Visa",
    duration:"YouTube",
    src:"https://www.youtube.com/embed/ief7LHHjlhs?rel=0&modestbranding=1",
    summary:"Channel: Hitesh Yadav",
  },
  {
    title:"Best Freezone in Dubai | Affordable | Zero Tax | How to start Business in Dubai | Hitesh Yadav",
    category:"Best Freezone",
    duration:"YouTube",
    src:"https://www.youtube.com/embed/lh6fTku8Dd8?start=39&rel=0&modestbranding=1",
    summary:"Channel: Hitesh Yadav",
  },
  {
    title:"Dubai Mainland License vs Dubai Freezone License | 2026 | Start Business in Dubai | Hitesh Yadav",
    category:"Mainland vs Freezone",
    duration:"YouTube",
    src:"https://www.youtube.com/embed/JMG75o25Wxo?rel=0&modestbranding=1",
    summary:"Channel: Hitesh Yadav",
  },
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=Inter:wght@300;400;500;600&display=swap');
  @import url('https://cdn-uicons.flaticon.com/2.6.0/uicons-regular-rounded/css/uicons-regular-rounded.css');
  *, *::before, *::after { margin:0; padding:0; box-sizing:border-box; }
  html { scroll-behavior:smooth; }
  body { font-family:'Inter',sans-serif; background:#fff; color:#12141A; overflow-x:hidden; }
  ::-webkit-scrollbar{width:4px}
  ::-webkit-scrollbar-track{background:#F7F8FA}
  ::-webkit-scrollbar-thumb{background:#B8952A;border-radius:2px}
  .fi{line-height:1;vertical-align:middle}
  .serif{font-family:'Cormorant Garamond',serif}
  .gold-text{
    background:linear-gradient(135deg,#8C6E1A 0%,#D4A93A 50%,#8C6E1A 100%);
    -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;
  }
  .btn-gold{
    background:linear-gradient(135deg,#B8952A,#D4A93A);color:#fff;border:none;
    padding:13px 28px;font-family:'Inter',sans-serif;font-size:13px;font-weight:600;
    letter-spacing:.6px;text-transform:uppercase;cursor:pointer;border-radius:3px;transition:all .3s;
  }
  .btn-gold:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(184,149,42,.35)}
  .btn-ghost{
    background:transparent;color:#B8952A;border:1.5px solid #B8952A;padding:12px 26px;
    font-family:'Inter',sans-serif;font-size:13px;font-weight:600;
    letter-spacing:.6px;text-transform:uppercase;cursor:pointer;border-radius:3px;transition:all .3s;
  }
  .btn-ghost:hover{background:#FBF6EC;transform:translateY(-2px)}
  .nav-lnk{
    color:#4B5563;font-size:14px;font-weight:400;cursor:pointer;transition:color .2s;
    text-decoration:none;padding:4px 0;border-bottom:2px solid transparent;
  }
  .nav-lnk:hover{color:#B8952A;border-bottom-color:#B8952A}
  .mobile-menu-btn{display:none}
  .brand-logo-nav{
    height:36px;
    width:auto;
    display:block;
    filter:invert(1) brightness(0.08);
  }
  .brand-logo-footer{
    height:40px;
    width:auto;
    display:block;
  }
  .footer-socials{
    display:flex;
    gap:10px;
    flex-wrap:wrap;
  }
  .footer-social-link{
    width:34px;
    height:34px;
    display:inline-flex;
    align-items:center;
    justify-content:center;
    color:rgba(255,255,255,0.72);
    background:rgba(255,255,255,0.03);
    border:1px solid rgba(255,255,255,0.18);
    border-radius:999px;
    text-decoration:none;
    transition:all .25s ease;
  }
  .footer-social-link:hover{
    color:#FFFFFF;
    border-color:#D4A93A;
    background:rgba(212,169,58,0.18);
    transform:translateY(-2px);
  }
  .service-hero-image{width:100%;height:360px;object-fit:cover;display:block}
  .blog-hero-image{width:100%;height:420px;object-fit:cover;display:block}
  .blog-related-image{width:100%;height:170px;object-fit:cover;display:block}
  .about-media-col{flex:0 0 420px;position:relative}
  .about-media-main{height:340px}
  .about-media-badge{position:absolute;bottom:-20px;right:-16px}
  .contact-layout{display:flex;gap:60px;flex-wrap:wrap;align-items:flex-start}
  .contact-side{flex:0 0 320px}
  .contact-form-col{flex:1;min-width:300px}
  .contact-form-card{
    background:#fff;
    border:1px solid #E5E7EB;
    border-radius:10px;
    padding:30px;
    box-shadow:0 14px 44px rgba(18,20,26,0.08);
  }
  .contact-page-actions{display:flex;gap:12px;flex-wrap:wrap;margin-top:18px}
  .trust-marquee{
    max-width:1280px;
    margin:0 auto;
    overflow:hidden;
    position:relative;
  }
  .trust-track{
    display:flex;
    align-items:center;
    width:max-content;
    animation:trustScroll 24s linear infinite;
  }
  .trust-marquee:hover .trust-track{animation-play-state:paused}
  .trust-seq{
    display:flex;
    align-items:center;
    gap:12px;
    padding-right:12px;
  }
  .trust-item{
    color:rgba(255,255,255,0.88);
    font-size:12px;
    display:inline-flex;
    align-items:center;
    gap:7px;
    white-space:nowrap;
    background:rgba(255,255,255,0.08);
    border:1px solid rgba(255,255,255,0.14);
    border-radius:999px;
    padding:8px 12px;
    flex:0 0 auto;
  }
  @keyframes trustScroll{
    from{transform:translateX(0)}
    to{transform:translateX(-50%)}
  }
  .lbl{
    display:inline-flex;align-items:center;gap:8px;font-size:11px;font-weight:600;
    letter-spacing:3px;text-transform:uppercase;color:#B8952A;margin-bottom:14px;
  }
  .lbl::before{content:'';width:20px;height:1.5px;background:#B8952A;display:block;}
  .card{
    background:#fff;border:1px solid #E5E7EB;border-radius:6px;
    transition:all .35s cubic-bezier(.25,.46,.45,.94);
  }
  .card:hover{transform:translateY(-5px);border-color:#D4A93A;box-shadow:0 12px 40px rgba(184,149,42,.12)}
  .faq-row{border-bottom:1px solid #E5E7EB}
  .faq-btn{
    width:100%;background:none;border:none;font-family:'Inter',sans-serif;font-size:15px;
    font-weight:500;color:#12141A;text-align:left;padding:20px 0;
    cursor:pointer;display:flex;justify-content:space-between;align-items:center;gap:16px;
  }
  .faq-body{font-size:14px;line-height:1.85;color:#6B7280;max-height:0;overflow:hidden;transition:max-height .4s ease,padding .3s ease;padding-bottom:0}
  .faq-body.open{max-height:560px;padding-bottom:20px}
  input,textarea{
    background:#F7F8FA;border:1px solid #E5E7EB;color:#12141A;
    font-family:'Inter',sans-serif;font-size:14px;padding:13px 16px;
    border-radius:4px;width:100%;outline:none;transition:border-color .25s,background .25s;
  }
  input:focus,textarea:focus{border-color:#B8952A;background:#fff}
  input::placeholder,textarea::placeholder{color:#9CA3AF}
  textarea{resize:vertical;min-height:110px}
  @keyframes fadeUp{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:translateY(0)}}
  .fu{animation:fadeUp .7s ease both}
  .fu1{animation-delay:.1s}.fu2{animation-delay:.2s}.fu3{animation-delay:.3s}
  @media(max-width:900px){
    .g4{grid-template-columns:1fr 1fr!important}
    .g3{grid-template-columns:1fr 1fr!important}
    .g2{grid-template-columns:1fr!important}
    .sg{grid-template-columns:1fr 1fr!important}
    .f2{grid-template-columns:1fr!important}
    .fg{grid-template-columns:1fr 1fr!important}
    .hflex{flex-direction:column!important}
    .hflex{gap:32px!important}
    .h900{display:none!important}
    .mobile-menu-btn{display:block!important}
    .nav-lnk{font-size:15px;padding:10px 0}
    .hh{font-size:44px!important}
    #about{padding:84px 5%!important}
    .about-media-col{flex:1 1 100%!important;max-width:540px;width:100%;margin:0 auto}
    .about-media-main{height:300px!important}
    .about-media-count{font-size:88px!important}
    .about-media-badge{
      position:relative!important;
      right:auto!important;
      bottom:auto!important;
      margin:14px auto 0!important;
      width:fit-content;
      max-width:95%;
    }
    .trust-seq{gap:10px;padding-right:10px}
    .trust-item{font-size:11px;padding:7px 10px}
    .contact-layout{gap:28px!important;align-items:stretch!important}
    .contact-side,.contact-form-col{
      flex:1 1 100%!important;
      min-width:0!important;
      max-width:none!important;
    }
    .contact-form-card{padding:24px!important}
    #contact h2{font-size:40px!important;line-height:1.2!important}
    #contact-page h1{font-size:42px!important;line-height:1.2!important}
    #service-page,#blog-page,#faq-page,#contact-page,#contact{padding:112px 5% 74px!important}
    #service-page h1,#blog-page h1,#faq-page h1,#contact-page h1{font-size:42px!important}
    #service-page h3,#blog-page h3{font-size:28px!important}
    .service-hero-image{height:300px!important}
    .blog-hero-image{height:320px!important}
  }
  @media(max-width:560px){
    .g4{grid-template-columns:1fr!important}
    .g3{grid-template-columns:1fr!important}
    .g2{grid-template-columns:1fr!important}
    .sg{grid-template-columns:1fr!important}
    .hh{font-size:34px!important}
    .fg{grid-template-columns:1fr!important}
    .f2{grid-template-columns:1fr!important}
    .hflex{gap:22px!important}
    .lbl{letter-spacing:2px}
    #about{padding:72px 5%!important}
    .about-media-main{height:240px!important}
    .about-media-count{font-size:66px!important}
    .about-media-caption{font-size:15px!important;text-align:center;padding:0 12px}
    .about-media-badge{padding:12px 14px!important;gap:10px!important}
    .trust-seq{gap:8px;padding-right:8px}
    .trust-item{font-size:10px;padding:7px 9px}
    .trust-track{animation-duration:18s}
    .contact-form-card{padding:18px!important}
    .contact-page-actions{gap:10px!important}
    #contact h2,#contact-page h1{font-size:32px!important;line-height:1.22!important}
    .fu3 .btn-gold,.fu3 .btn-ghost,
    #faq-home .btn-gold,
    #service-page .btn-gold,#service-page .btn-ghost,
    #blog-page .btn-gold,#blog-page .btn-ghost,
    #contact-page .btn-gold,#contact-page .btn-ghost{
      width:100%;justify-content:center
    }
    #service-page,#blog-page,#faq-page,#contact-page,#contact{padding:102px 5% 64px!important}
    #service-page h1,#blog-page h1,#faq-page h1,#contact-page h1{font-size:33px!important}
    #service-page h3,#blog-page h3{font-size:24px!important}
    .service-hero-image{height:220px!important}
    .blog-hero-image{height:220px!important}
    .blog-related-image{height:150px!important}
    .brand-logo-nav{height:30px}
    .brand-logo-footer{height:34px}
    .footer-social-link{width:32px;height:32px}
  }
  .whatsapp-btn{
    position:fixed;bottom:20px;right:20px;width:60px;height:60px;background:#25D366;border-radius:50%;
    display:flex;align-items:center;justify-content:center;box-shadow:0 4px 12px rgba(0,0,0,0.3);
    cursor:pointer;z-index:1000;transition:all .3s;text-decoration:none;
    animation:whatsappWiggle 2.2s ease-in-out infinite;
  }
  .whatsapp-btn:hover{transform:scale(1.08);animation-play-state:paused}
  @keyframes whatsappWiggle{
    0%,100%{transform:translateY(0) rotate(0deg)}
    25%{transform:translateY(-2px) rotate(-2deg)}
    50%{transform:translateY(0) rotate(0deg)}
    75%{transform:translateY(-2px) rotate(2deg)}
  }
`;

const SERVICES = [
  {
    slug:"business-license",
    icon:"building",
    t:"Business License",
    d:"End-to-end company formation, trade licensing, and legal registration across UAE jurisdictions.",
    image:"https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1400&q=80",
    long:"We help you launch with the right legal structure from day one. Our team compares Mainland, Freezone, and Offshore options, aligns activity codes correctly, and manages every approval step so your business starts without delays or compliance surprises.",
    includes:[
      "Business activity mapping and jurisdiction selection",
      "Trade name reservation and initial approvals",
      "MOA/AOA drafting, notarization, and authority submissions",
      "License issuance, establishment card, and renewal planning",
    ],
    process:[
      "Discovery call to understand your business model and growth goals",
      "Shortlisting of best-fit jurisdictions with transparent cost comparison",
      "Document preparation, approvals, and authority coordination",
      "Final license handover with post-setup checklist and support",
    ],
    outcomes:[
      "Legally compliant market entry",
      "Faster time to launch and operate",
      "Clear annual renewal and compliance roadmap",
    ],
    timeline:"Typical completion: 3 to 10 business days based on activity and authority approvals.",
  },
  {
    slug:"visa-pro-services",
    icon:"passport",
    t:"Visa & PRO Services",
    d:"Visa processing, Emirates ID, labour cards, and complete government liaison on your behalf.",
    image:"https://images.unsplash.com/photo-1521790797524-b2497295b8a0?auto=format&fit=crop&w=1400&q=80",
    long:"Our PRO specialists handle all immigration and labor formalities so you can focus on operations. From investor visas to employee onboarding, we reduce bottlenecks and keep every filing compliant with current UAE rules.",
    includes:[
      "Investor, partner, employee, and dependent visa processing",
      "Medical, biometrics, Emirates ID, and stamping coordination",
      "Labor card, establishment updates, and quota support",
      "Ongoing renewals, cancellations, and status amendments",
    ],
    process:[
      "Eligibility and document audit before filing",
      "Application submissions with immigration and labor departments",
      "Appointment scheduling and end-to-end tracking",
      "Visa issuance confirmation and renewal calendar setup",
    ],
    outcomes:[
      "Reduced delays in visa processing",
      "Accurate submissions with fewer rejections",
      "Smooth onboarding for founders and team members",
    ],
    timeline:"Typical completion: 5 to 15 business days depending on visa type and medical/immigration slots.",
  },
  {
    slug:"taxation-accounting",
    icon:"calculator-math-tax",
    t:"Taxation & Accounting",
    d:"VAT filing, corporate tax, bookkeeping, payroll, and full financial management services.",
    image:"https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1400&q=80",
    long:"We build clean financial systems that protect your business from penalties and improve decision-making. From monthly bookkeeping to VAT and corporate tax compliance, our finance team keeps your records accurate and audit-ready.",
    includes:[
      "Monthly bookkeeping and management reporting",
      "VAT registration, returns, and FTA compliance",
      "Corporate tax registration and filing support",
      "Payroll setup, reconciliations, and year-end closing",
    ],
    process:[
      "Chart of accounts and accounting workflow setup",
      "Transaction categorization and monthly reconciliation",
      "Tax review with filing calendar and deadline alerts",
      "Performance reports and compliance-ready documentation",
    ],
    outcomes:[
      "Accurate cash-flow visibility",
      "Lower compliance risk and late penalties",
      "Better strategic planning with reliable numbers",
    ],
    timeline:"Implementation can start within 2 business days; monthly cycles continue as per agreed reporting scope.",
  },
  {
    slug:"uae-golden-visa",
    icon:"crown",
    t:"UAE Golden Visa",
    d:"Long-term residency for investors, entrepreneurs, and outstanding talented professionals.",
    image:"https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1400&q=80",
    long:"We evaluate your profile against current Golden Visa pathways and prepare a complete application strategy. Our team manages the process from documentation to approvals, helping you secure long-term residency with clarity and confidence.",
    includes:[
      "Eligibility assessment across investor and professional categories",
      "Document checklist, attestations, and file preparation",
      "Application submission and authority follow-up",
      "Residency stamping and dependent sponsorship guidance",
    ],
    process:[
      "Profile screening and criteria matching",
      "Document preparation with quality checks",
      "Submission, tracking, and escalation support",
      "Final visa issuance and post-approval assistance",
    ],
    outcomes:[
      "Higher approval readiness",
      "Less documentation stress",
      "Clear pathway for family residency planning",
    ],
    timeline:"Typical processing timeline ranges from 2 to 8 weeks based on category and authority review.",
  },
  {
    slug:"banking-compliance",
    icon:"bank",
    t:"Banking & Compliance",
    d:"Corporate bank account opening, KYC, AML compliance, and financial advisory support.",
    image:"https://images.unsplash.com/photo-1565514020179-026b92b84bb6?auto=format&fit=crop&w=1400&q=80",
    long:"Opening a UAE corporate bank account requires strong documentation and a clear compliance narrative. We prepare your file, optimize KYC responses, and guide you through interviews and follow-ups with partner banks.",
    includes:[
      "Bank readiness review and account strategy",
      "KYC document pack preparation and narrative support",
      "Meeting/interview guidance and bank liaison",
      "AML compliance workflow recommendations",
    ],
    process:[
      "Business profile and transaction pattern assessment",
      "Shortlist of suitable banks by activity and risk appetite",
      "KYC pack build and submission support",
      "Follow-up tracking until account activation",
    ],
    outcomes:[
      "Improved probability of account approval",
      "Cleaner compliance posture for future banking needs",
      "Faster response handling with documented clarity",
    ],
    timeline:"Most applications close within 2 to 8 weeks depending on bank and business profile.",
  },
  {
    slug:"company-auditing",
    icon:"audit-alt",
    t:"Company Auditing",
    d:"Statutory audits, internal reviews, and independent financial due diligence reports.",
    image:"https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1400&q=80",
    long:"Our audit practice helps businesses maintain regulatory confidence and stakeholder trust. We deliver structured audits, internal control assessments, and actionable findings that strengthen financial governance.",
    includes:[
      "Statutory audit execution and signed reports",
      "Internal controls review and gap analysis",
      "Management letter with risk-priority actions",
      "Due diligence support for investors and acquisitions",
    ],
    process:[
      "Planning and risk scoping with management team",
      "Evidence collection and test procedures",
      "Issue discussion and remediation recommendations",
      "Final report issuance and follow-up support",
    ],
    outcomes:[
      "Audit-ready financial operations",
      "Better control environment and governance",
      "Higher stakeholder confidence",
    ],
    timeline:"Typical audit cycle: 2 to 6 weeks depending on records quality and business complexity.",
  },
  {
    slug:"europe-visa",
    icon:"earth-europa",
    t:"Europe Visa",
    d:"Schengen, UK, and European visa processing with documentation and interview preparation.",
    image:"https://images.unsplash.com/photo-1467269204594-9661b134dd2b?auto=format&fit=crop&w=1400&q=80",
    long:"We support travelers, founders, and professionals with end-to-end European visa preparation. From document structuring to interview readiness, our process minimizes rejection risk and improves submission quality.",
    includes:[
      "Country-specific visa checklist and documentation support",
      "Travel itinerary and cover letter structuring",
      "Appointment booking and application review",
      "Interview guidance and reapplication strategy if needed",
    ],
    process:[
      "Eligibility and travel-purpose validation",
      "Document pack assembly and quality review",
      "Submission support and appointment prep",
      "Post-submission tracking and response handling",
    ],
    outcomes:[
      "Stronger visa file quality",
      "Reduced avoidable rejection causes",
      "Faster submission readiness",
    ],
    timeline:"Preparation typically takes 3 to 7 business days; embassy processing varies by country and season.",
  },
  {
    slug:"dual-citizenship",
    icon:"globe",
    t:"Dual Citizenship",
    d:"Citizenship-by-investment planning across Caribbean, European, and Asian programs.",
    image:"https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=1400&q=80",
    long:"We provide strategic advisory for second-passport and dual-citizenship pathways through approved global programs. Our team helps you evaluate legal, tax, and mobility outcomes before committing to any route.",
    includes:[
      "Program comparison by budget, timeline, and mobility score",
      "Eligibility pre-screening and due-diligence planning",
      "File preparation with authorized partner coordination",
      "Family inclusion strategy and long-term planning",
    ],
    process:[
      "Goal assessment and shortlist of eligible programs",
      "Compliance checks and documentation planning",
      "Application management with authorized channels",
      "Approval, passport issuance, and post-approval guidance",
    ],
    outcomes:[
      "Clear decision-making with risk visibility",
      "Well-structured multi-country mobility strategy",
      "Professional guidance through each legal step",
    ],
    timeline:"Varies by program; most pathways range between 4 and 12 months end-to-end.",
  },
];

const WHY = [
  {icon:"target",t:"Expert Consultation", d:"Licensed consultants with deep UAE business law expertise from day one."},
  {icon:"handshake",t:"End-to-End Support",  d:"License, visa, banking — every step handled under one roof."},
  {icon:"badge-dollar",t:"Transparent Pricing", d:"No hidden fees. Clear cost breakdowns before you commit to anything."},
  {icon:"bolt",t:"Fast Processing",     d:"Government relationships ensure faster approvals and shorter turnarounds."},
  {icon:"award",t:"5,000+ Successes",    d:"Thousands of businesses launched across diverse industries."},
  {icon:"language",t:"Multilingual Team",   d:"English, Arabic, Hindi, and more — seamless communication guaranteed."},
  {icon:"shield-check",t:"Post-Setup Support",  d:"Ongoing PRO, accounting, and compliance support long after launch."},
  {icon:"sparkles",t:"Tailored Solutions",  d:"Custom strategies based on your goals, budget, and industry sector."},
];

const UAE = [
  {n:"01",t:"100% Ownership",     d:"Full foreign ownership with no local sponsor needed in most UAE jurisdictions."},
  {n:"02",t:"Zero Personal Tax",  d:"No personal income tax; minimal corporate tax with wide sectoral exemptions."},
  {n:"03",t:"Global Gateway",     d:"Strategic location bridging Europe, Asia, and Africa for seamless global trade."},
  {n:"04",t:"Quick Setup",        d:"Company formation in as little as 3 business days in leading Free Zones."},
  {n:"05",t:"Multiple Activities",d:"Thousands of licensed business activities to match any industry or vision."},
  {n:"06",t:"World-Class Banking",d:"Reliable, internationally connected corporate banking with full support."},
];

const FAQS = [
  {
    q:"What is the difference between a Freezone and a Mainland company in the UAE?",
    a:"A Mainland company can operate across the UAE market directly and take government contracts in many sectors. A Freezone company offers strong setup incentives, simpler processes, and 100% ownership, but may need a distributor or branch model for some direct Mainland trading activities.",
  },
  {
    q:"Can I own 100% of my company in the UAE?",
    a:"Yes, 100% foreign ownership is allowed in most business activities. However, a few specific activities are restricted and may require local ownership or involvement.",
  },
  {
    q:"How long does it take to set up a company in the UAE?",
    a:"Most Freezone setups are completed in about 3 to 7 business days, while Mainland setups usually take around 7 to 14 business days depending on activity approvals and document readiness.",
  },
  {
    q:"What documents are required to start a business in the UAE?",
    a:"Usually you need passport copies of shareholders, passport-size photos, proposed business activity details, and application forms. Some activities may also require business plans, NOC letters, or additional regulatory approvals.",
  },
  {
    q:"Do I need to visit the UAE to open a company?",
    a:"In many Freezones, initial company setup can be done remotely. A visit may still be required later for biometrics, visa stamping, or bank account formalities depending on your chosen jurisdiction and bank.",
  },
  {
    q:"What is the cost of starting a company in the UAE?",
    a:"Costs vary by jurisdiction, business activity, visa quota, and office requirements. Entry-level Freezone packages may start lower, while Mainland or regulated activities can be higher. A transparent cost sheet should include license, immigration, office, and government fees.",
  },
  {
    q:"How many visas can I get with my company?",
    a:"Visa eligibility depends on your license type, office size, and authority rules. Some packages include limited visas, while larger office space or different activity categories can increase quota.",
  },
  {
    q:"Is office space mandatory for company setup?",
    a:"Most licenses require a registered address. Many Freezones provide flexi-desk or shared desk options, while Mainland businesses typically need an Ejari-registered tenancy agreement.",
  },
  {
    q:"Can I open a corporate bank account in the UAE easily?",
    a:"It is possible, but banks follow strict compliance checks. Proper documentation, a clear business model, and transparent source of funds significantly improve approval chances.",
  },
  {
    q:"What is the timeline for opening a corporate bank account?",
    a:"The process usually takes 2 to 8 weeks, depending on the bank, business activity, shareholder profile, and compliance review depth.",
  },
  {
    q:"What are the benefits of setting up a business in the UAE?",
    a:"Key benefits include strategic global location, business-friendly regulations, strong infrastructure, tax advantages in many structures, and access to international markets and talent.",
  },
  {
    q:"Do I need a local sponsor for a Mainland company?",
    a:"For most activities, no local sponsor is required due to updated ownership laws. However, a few strategic or restricted sectors may still have special local participation requirements.",
  },
  {
    q:"Can I run multiple business activities under one license?",
    a:"Yes, many jurisdictions allow multiple related activities under one license, subject to authority rules. Highly regulated combinations may require additional approvals or separate licenses.",
  },
  {
    q:"What makes your service different from the competition?",
    a:"Launch Leap focuses on transparent pricing, tailored setup strategy, faster execution support, and end-to-end post-incorporation assistance including visa, banking, compliance, and renewals.",
  },
  {
    q:"What is VAT in the UAE, and do I need to register?",
    a:"VAT is a value-added tax applied to most goods and services. Registration is mandatory once taxable supplies cross the legal threshold, and voluntary registration may be possible below that threshold in eligible cases.",
  },
  {
    q:"Can I start a business in the UAE while living abroad?",
    a:"Yes, many entrepreneurs start remotely with consultant support. You may still need to travel later for selected steps like biometrics or specific banking processes.",
  },
  {
    q:"What is the validity of a UAE trade license?",
    a:"Most trade licenses are valid for one year and must be renewed before expiry to avoid penalties and service disruptions.",
  },
  {
    q:"Can I sponsor my family with a UAE visa?",
    a:"Yes, business owners and eligible residents can usually sponsor spouse, children, and in some cases parents, subject to income, accommodation, and immigration criteria.",
  },
  {
    q:"What happens if I do not renew my trade license on time?",
    a:"Late renewal can lead to fines, immigration and banking interruptions, and possible blacklisting risks if ignored for long periods. Renewal planning before expiry is strongly recommended.",
  },
  {
    q:"Why should I choose Launch Leap for company formation?",
    a:"We provide complete setup guidance under one roof: jurisdiction planning, licensing, visa processing, banking support, compliance, and renewals. You get practical advice, clear timelines, and transparent fee structure.",
  },
];

const BLOGS = [
  {
    slug:"business-setup-dubai-complete-guide",
    image:"/blog-1.jpg",
    cat:"Management",
    date:"26 Sep 2025",
    read:"8 min read",
    title:"Business Setup in Dubai Made Easy: The Complete Guide for Entrepreneurs",
    excerpt:"A practical roadmap for choosing the right jurisdiction, getting your license, and launching operations smoothly in the UAE.",
    intro:"Starting in Dubai becomes much easier when you break the process into structured phases. From choosing your activity code to opening your bank account, each step has compliance checkpoints that impact both timeline and cost.",
    highlights:[
      "Choose jurisdiction based on your business model, not only package price.",
      "Plan licensing, immigration, and banking together to reduce delays.",
      "Keep a clear renewal and compliance calendar from day one.",
    ],
    sections:[
      {
        h:"1) Pick the right structure first",
        p:"Mainland, Freezone, and Offshore structures serve different goals. If you need direct UAE market access, Mainland can be ideal. If you prioritize faster setup and simplified frameworks, many Freezones offer strong advantages.",
      },
      {
        h:"2) Build documents with compliance in mind",
        p:"Trade name approvals, activity alignment, shareholder documents, and application forms should be prepared precisely. Early errors can trigger rejection cycles that delay launch by weeks.",
      },
      {
        h:"3) Execute setup as a single workflow",
        p:"License issuance, visa processing, and bank onboarding should move in coordinated sequence. A unified workflow helps avoid duplicated submissions and keeps your launch timeline predictable.",
      },
    ],
  },
  {
    slug:"cost-to-start-business-dubai-breakdown",
    image:"/blog-2.jpg",
    cat:"Business Consulting",
    date:"26 Sep 2025",
    read:"7 min read",
    title:"How Much Does It Cost to Start a Business in Dubai? Full Breakdown",
    excerpt:"Understand real setup costs beyond license fees, including immigration, office requirements, compliance, and operating overheads.",
    intro:"Many founders underestimate total setup spend because they only compare initial license prices. A complete budget should include immigration, legal processing, office compliance, and first-year operational essentials.",
    highlights:[
      "Total cost depends on activity type, visa quota, and office model.",
      "Hidden costs are avoided when all government and admin fees are itemized.",
      "A 12-month budget gives better decision control than a launch-only estimate.",
    ],
    sections:[
      {
        h:"1) Core government setup costs",
        p:"These include trade name, initial approvals, license issuance, and establishment-related fees. Regulated activities may require additional authority clearances and professional approvals.",
      },
      {
        h:"2) Immigration and staffing costs",
        p:"Visa processing, medical tests, Emirates ID, labor setup, and quota-linked items should be budgeted early. If you plan immediate hiring, include onboarding costs in your first-year plan.",
      },
      {
        h:"3) Banking, accounting, and compliance",
        p:"Post-incorporation costs such as bookkeeping, VAT/corporate tax support, and annual renewals are business-critical. Planning these in advance prevents compliance stress later.",
      },
    ],
  },
  {
    slug:"mainland-vs-freezone-dubai-comparison",
    image:"/blog-3.jpg",
    cat:"Management",
    date:"26 Sep 2025",
    read:"9 min read",
    title:"Mainland vs Free Zone in Dubai: Which Structure Should You Choose?",
    excerpt:"A side-by-side comparison to help founders choose the right legal setup for growth, cost control, and operational flexibility.",
    intro:"This is one of the most important early decisions for entrepreneurs in the UAE. The right structure depends on your customer base, growth model, visa strategy, and compliance capacity.",
    highlights:[
      "Mainland supports broad UAE market access and many local commercial activities.",
      "Freezones offer efficient setup pathways and strong founder-friendly frameworks.",
      "The best choice is strategic fit, not only setup speed or initial fee.",
    ],
    sections:[
      {
        h:"1) Market access and business flexibility",
        p:"Mainland entities can generally operate across the UAE market directly. Freezone companies may require specific distribution models for some Mainland activities, depending on business type and authority rules.",
      },
      {
        h:"2) Cost and operational structure",
        p:"Freezone packages can be attractive at launch, especially for smaller teams. Mainland can deliver long-term operational flexibility, but final cost depends on office and activity requirements.",
      },
      {
        h:"3) Long-term expansion planning",
        p:"Your five-year growth plan should drive the final choice. If future hiring scale, local trade depth, and licensing breadth are priorities, evaluate structure through long-term operational impact.",
      },
    ],
  },
];

const TRUST_ITEMS = [
  {icon:"award",text:"10+ Years of Excellence"},
  {icon:"users",text:"1,000+ Clients"},
  {icon:"badge-percent",text:"99% Success Rate"},
  {icon:"language",text:"Multilingual Team"},
  {icon:"building",text:"Dubai Licensed"},
];

const BUSINESS_PHONE = "+971 50 151 9935";
const WHATSAPP_PHONE = BUSINESS_PHONE.replace(/\D/g,"");
const WHATSAPP_DEFAULT_MESSAGE = "Hi LaunchLeap, I would like help with starting my business in Dubai.";
const buildWhatsAppLink = (message) => `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`;
const WHATSAPP_LINK = buildWhatsAppLink(WHATSAPP_DEFAULT_MESSAGE);

const CONTACT_ITEMS = [
  {icon:"map-marker",label:"Headquarters",value:"Dubai, United Arab Emirates"},
  {icon:"envelope",label:"Email",value:"info@launchleap.com"},
  {icon:"phone-call",label:"Phone",value:BUSINESS_PHONE},
];
const SOCIAL_LINKS = [
  {id:"x",label:"X",href:"https://x.com/thelaunchleap"},
  {id:"youtube",label:"YouTube",href:"https://www.youtube.com/@hiteshyadavonly"},
  {id:"facebook",label:"Facebook",href:"https://www.facebook.com/people/thelaunchleap/61579513184417/?rdid=JsqkNIhbah52ZjAj&share_url=httpswww.facebook.comshare1C6v1DZYB4"},
  {id:"instagram",label:"Instagram",href:"https://www.instagram.com/thelaunchleap/"},
];

function useCountUp(target, ms=1400, go=false){
  const [v,setV]=useState(0);
  useEffect(()=>{
    if(!go){
      setV(0);
      return;
    }
    let t0=null;
    let rafId=0;
    const tick=(ts)=>{
      if(!t0)t0=ts;
      const p=Math.min((ts-t0)/ms,1);
      setV(Math.floor(p*target));
      if(p<1)rafId=requestAnimationFrame(tick);
    };
    rafId=requestAnimationFrame(tick);
    return()=>cancelAnimationFrame(rafId);
  },[target,ms,go]);
  return v;
}

function FaqRow({q,a}){
  const [open,setOpen]=useState(false);
  return(
    <div className="faq-row">
      <button type="button" className="faq-btn" onClick={()=>setOpen(!open)}>
        <span>{q}</span>
        <span style={{color:GOLD,fontSize:22,flexShrink:0,transition:"transform .3s",transform:open?"rotate(45deg)":"rotate(0)"}}>+</span>
      </button>
      <div className={`faq-body${open?" open":""}`}>{a}</div>
    </div>
  );
}

function FiIcon({name,size=20,color="currentColor",style={}}){
  return <i className={`fi fi-rr-${name}`} style={{fontSize:size,color,...style}} />;
}

function WhatsAppIcon({size=28,color=WHITE,style={}}){
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 16 16"
      style={{width:size,height:size,display:"block",...style}}
    >
      <path
        fill={color}
        d="M13.601 2.326A7.85 7.85 0 0 0 8.019 0C3.53 0 .89 3.665 .89 7.986c0 1.48.392 2.925 1.136 4.2L0 16l3.935-1.032a7.98 7.98 0 0 0 4.084 1.104h.003c4.488 0 8.128-3.665 8.128-7.986a7.96 7.96 0 0 0-2.549-5.76m-5.582 12.03a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.335.612.623-2.276-.157-.248a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.973-6.577 6.634-6.577a6.6 6.6 0 0 1 4.695 1.94 6.56 6.56 0 0 1 1.94 4.695c-.001 3.626-2.974 6.577-6.634 6.577m3.651-4.939c-.2-.1-1.183-.585-1.366-.652-.183-.066-.317-.099-.45.1-.132.197-.513.652-.628.785-.116.132-.232.149-.433.05-.2-.1-.844-.31-1.607-.995-.594-.53-.995-1.184-1.111-1.383-.116-.198-.012-.306.087-.406.09-.09.2-.232.3-.347.1-.116.132-.198.2-.33.066-.133.033-.248-.017-.347-.05-.1-.45-1.083-.616-1.483-.161-.387-.325-.334-.45-.341h-.383c-.132 0-.347.05-.529.248-.182.199-.694.677-.694 1.65s.71 1.914.81 2.047c.099.132 1.4 2.13 3.383 2.987.472.204.84.326 1.127.418.474.152.905.13 1.246.079.38-.057 1.183-.484 1.35-.95.166-.463.166-.86.116-.95-.05-.09-.183-.149-.383-.248"
      />
    </svg>
  );
}

function SocialIcon({id,size=14,color="currentColor",style={}}){
  if(id==="x"){
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" style={{width:size,height:size,display:"block",...style}}>
        <path fill={color} d="M18.244 2H21.5l-7.12 8.14L22.8 22h-6.59l-5.16-6.75L5.16 22H1.9l7.61-8.7L1.2 2h6.76l4.66 6.16L18.244 2zm-1.16 18h1.83L6.97 3.9H5.01L17.084 20z"/>
      </svg>
    );
  }
  if(id==="youtube"){
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" style={{width:size,height:size,display:"block",...style}}>
        <path fill={color} d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.4 3.5 12 3.5 12 3.5s-7.4 0-9.4.6A3 3 0 0 0 .5 6.2 31.5 31.5 0 0 0 0 12a31.5 31.5 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c2 .6 9.4.6 9.4.6s7.4 0 9.4-.6a3 3 0 0 0 2.1-2.1A31.5 31.5 0 0 0 24 12a31.5 31.5 0 0 0-.5-5.8zM9.6 15.7V8.3L16 12z"/>
      </svg>
    );
  }
  if(id==="facebook"){
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" style={{width:size,height:size,display:"block",...style}}>
        <path fill={color} d="M13.5 21v-7h2.3l.3-2.7h-2.6V9.6c0-.8.2-1.3 1.4-1.3h1.5V5.9c-.3 0-1.2-.1-2.3-.1-2.2 0-3.8 1.3-3.8 3.8v1.7H8v2.7h2.3v7h3.2z"/>
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" style={{width:size,height:size,display:"block",...style}}>
      <rect x="3.5" y="3.5" width="17" height="17" rx="5" fill="none" stroke={color} strokeWidth="2"/>
      <circle cx="12" cy="12" r="4" fill="none" stroke={color} strokeWidth="2"/>
      <circle cx="17.3" cy="6.7" r="1.2" fill={color}/>
    </svg>
  );
}

function getRoutePath(){
  if(typeof window === "undefined")return "/";
  const hash = (window.location.hash || "").toLowerCase();
  if(hash.startsWith("#/")){
    const hashPath = hash.slice(1).replace(/\/+$/,"");
    return hashPath || "/";
  }
  return window.location.pathname.toLowerCase().replace(/\/+$/,"") || "/";
}

export default function App(){
  const [routePath,setRoutePath]=useState(getRoutePath);
  const [scrolled,setScrolled]=useState(false);
  const [statsGo,setStatsGo]=useState(false);
  const [menuOpen,setMenuOpen]=useState(false);
  const statsRef=useRef(null);
  const [form,setForm]=useState({name:"",phone:"",email:"",subject:"",msg:""});
  const [sent,setSent]=useState(false);
  const sentTimerRef = useRef(null);
  const [heroLead,setHeroLead]=useState({name:"",phone:"",email:"",idea:""});
  const [newsletterEmail,setNewsletterEmail]=useState("");

  useEffect(()=>{
    const fn=()=>setScrolled(window.scrollY>50);
    window.addEventListener("scroll",fn);
    return()=>window.removeEventListener("scroll",fn);
  },[]);

  useEffect(()=>{
    const ob=new IntersectionObserver(([e])=>{if(e.isIntersecting)setStatsGo(true);},{threshold:.3});
    if(statsRef.current)ob.observe(statsRef.current);
    return()=>ob.disconnect();
  },[]);

  useEffect(()=>{
    const syncRoute=()=>setRoutePath(getRoutePath());
    window.addEventListener("hashchange",syncRoute);
    window.addEventListener("popstate",syncRoute);
    return()=>{
      window.removeEventListener("hashchange",syncRoute);
      window.removeEventListener("popstate",syncRoute);
    };
  },[]);

  const s1=useCountUp(1000,1300,statsGo);
  const s2=useCountUp(10,1300,statsGo);
  const s3=useCountUp(99,1300,statsGo);
  const s4=useCountUp(5000,1300,statsGo);

  const submit=(e)=>{
    e.preventDefault();
    setSent(true);
    setForm({name:"",phone:"",email:"",subject:"",msg:""});
    if(sentTimerRef.current)clearTimeout(sentTimerRef.current);
    sentTimerRef.current=setTimeout(()=>setSent(false),4500);
  };

  useEffect(()=>()=>{ if(sentTimerRef.current)clearTimeout(sentTimerRef.current); },[]);

  const openExternalUrl = (url) => {
    if(typeof window === "undefined")return;
    const opened = window.open(url,"_blank","noopener,noreferrer");
    if(!opened)window.location.href = url;
  };

  const submitHeroLead = (e) => {
    e.preventDefault();
    const msg = [
      "Hi LaunchLeap, I want a free consultation.",
      `Name: ${heroLead.name}`,
      `Phone: ${heroLead.phone}`,
      `Email: ${heroLead.email}`,
      `Business Idea: ${heroLead.idea}`,
    ].join("\n");
    openExternalUrl(buildWhatsAppLink(msg));
    setHeroLead({name:"",phone:"",email:"",idea:""});
  };

  const submitNewsletter = (e) => {
    e.preventDefault();
    if(!newsletterEmail.trim())return;
    const subject = encodeURIComponent("Newsletter Subscription Request");
    const body = encodeURIComponent(`Please subscribe this email to LaunchLeap updates: ${newsletterEmail.trim()}`);
    if(typeof window !== "undefined")window.location.href = `mailto:info@launchleap.com?subject=${subject}&body=${body}`;
    setNewsletterEmail("");
  };

  const serviceMatch = routePath.match(/^\/services\/([^/]+)$/);
  const blogMatch = routePath.match(/^\/blog\/([^/]+)$/);
  const activeService = serviceMatch ? SERVICES.find((s)=>s.slug===serviceMatch[1]) : null;
  const activeBlog = blogMatch ? BLOGS.find((b)=>b.slug===blogMatch[1]) : null;
  const isServicePage = !!activeService;
  const isBlogPage = !!activeBlog;
  const isFaqPage = routePath === "/faq";
  const isContactPage = routePath === "/contact";
  const isHomePage = routePath === "/";
  const isNotFoundPage = !isHomePage && !isFaqPage && !isContactPage && !isServicePage && !isBlogPage;
  const relatedServices = activeService
    ? SERVICES.filter((s)=>s.slug!==activeService.slug).slice(0,3)
    : [];
  const relatedBlogs = activeBlog
    ? BLOGS.filter((b)=>b.slug!==activeBlog.slug).slice(0,3)
    : [];
  const NAV = isHomePage
    ? [
      {label:"About Us",href:"#about"},
      {label:"Our Services",href:"#services"},
      {label:"Videos",href:"#videos"},
      {label:"Why UAE?",href:"#why-uae"},
      {label:"Blog",href:"#blog"},
      {label:"FAQ",href:"#/faq"},
      {label:"Contact Us",href:"#/contact"},
    ]
    : [
      {label:"About Us",href:"/#about"},
      {label:"Our Services",href:"/#services"},
      {label:"Videos",href:"/#videos"},
      {label:"Why UAE?",href:"/#why-uae"},
      {label:"Blog",href:"/#blog"},
      {label:"FAQ",href:"#/faq"},
      {label:"Contact Us",href:"#/contact"},
    ];
  const FOOTER_QUICK_LINKS = isHomePage
    ? [
      {label:"About Us",href:"#about"},
      {label:"Our Services",href:"#services"},
      {label:"Why UAE?",href:"#why-uae"},
      {label:"FAQ",href:"#/faq"},
      {label:"Blog",href:"#blog"},
      {label:"Contact",href:"#/contact"},
    ]
    : [
      {label:"About Us",href:"/#about"},
      {label:"Our Services",href:"/#services"},
      {label:"Why UAE?",href:"/#why-uae"},
      {label:"FAQ",href:"#/faq"},
      {label:"Blog",href:"/#blog"},
      {label:"Contact",href:"#/contact"},
    ];
  const FOOTER_SERVICE_LINKS = SERVICES.map((s)=>({
    label:s.t,
    href:`#/services/${s.slug}`,
  }));

  return(
    <div style={{background:WHITE,color:DARK,minHeight:"100vh"}}>
      <style>{CSS}</style>

      {/* NAVBAR */}
      <nav style={{
        position:"fixed",top:0,left:0,right:0,zIndex:100,
        background:(scrolled||!isHomePage)?"rgba(255,255,255,0.97)":"transparent",
        backdropFilter:(scrolled||!isHomePage)?"blur(16px)":"none",
        borderBottom:(scrolled||!isHomePage)?`1px solid ${BORDER}`:"none",
        transition:"all .35s ease",padding:"0 5%",
      }}>
        <div style={{maxWidth:1280,margin:"0 auto",display:"flex",alignItems:"center",justifyContent:"space-between",height:72}}>
          <a href="/" style={{textDecoration:"none",display:"inline-flex",alignItems:"center"}}>
            <img src={BRAND_LOGO_IMAGE} alt="LaunchLeap" className="brand-logo-nav"/>
          </a>
          <div className="h900" style={{display:"flex",gap:32}}>
            {NAV.map(({label,href})=>(
              <a key={label} href={href} className="nav-lnk">{label}</a>
            ))}
          </div>
          <div className="h900" style={{display:"flex",gap:10}}>
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noreferrer"
              className="btn-ghost"
              style={{padding:"10px 18px",fontSize:12,display:"inline-flex",alignItems:"center",gap:8,textDecoration:"none"}}
              aria-label="Chat with LaunchLeap on WhatsApp"
            >
              <FiIcon name="message-sms" size={13}/>
              WhatsApp
            </a>
            <a href="#/contact" style={{textDecoration:"none"}}>
              <button className="btn-gold" style={{padding:"10px 20px",fontSize:12}}>Get a Quote</button>
            </a>
          </div>
          <button onClick={()=>setMenuOpen(!menuOpen)}
            style={{display:"none",background:"none",border:"none",fontSize:24,cursor:"pointer",color:DARK}}
            className="mobile-menu-btn"><FiIcon name="menu-burger" size={22} color={DARK}/></button>
        </div>
        {menuOpen&&(
          <div style={{background:WHITE,borderTop:`1px solid ${BORDER}`,padding:"20px 5%",display:"flex",flexDirection:"column",gap:16}}>
            {NAV.map(({label,href})=>(
              <a key={label} href={href} className="nav-lnk" onClick={()=>setMenuOpen(false)}>{label}</a>
            ))}
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noreferrer"
              className="btn-ghost"
              style={{marginTop:8,textDecoration:"none",display:"inline-flex",alignItems:"center",justifyContent:"center",gap:8}}
              onClick={()=>setMenuOpen(false)}
              aria-label="Chat with LaunchLeap on WhatsApp"
            >
              <FiIcon name="message-sms" size={14}/>
              WhatsApp
            </a>
            <a href="#/contact" style={{textDecoration:"none"}} onClick={()=>setMenuOpen(false)}>
              <button className="btn-gold" style={{marginTop:8,width:"100%"}}>Get a Quote</button>
            </a>
          </div>
        )}
      </nav>

      {isHomePage ? (
        <>
      {/* HERO */}
      <section style={{minHeight:"100vh",padding:"120px 5% 80px",position:"relative",overflow:"hidden",
        background:`linear-gradient(160deg,${WHITE} 55%,${GOLD_BG} 100%)`}}>
        <video
          autoPlay
          muted
          loop
          playsInline
          style={{
            position:"absolute",
            inset:0,
            width:"100%",
            height:"100%",
            objectFit:"cover",
            zIndex:0,
            pointerEvents:"none",
          }}
        >
          <source src={HERO_VIDEO} type="video/mp4" />
        </video>
        <div style={{position:"absolute",inset:0,zIndex:1,
          background:`linear-gradient(160deg,rgba(255,255,255,0.88) 36%,rgba(251,246,236,0.7) 100%)`}}/>

        <div style={{position:"absolute",right:"-6%",top:"8%",width:520,height:520,borderRadius:"50%",
          background:`radial-gradient(circle,${GOLD_BG} 0%,transparent 70%)`,pointerEvents:"none",zIndex:2}}/>
        <div style={{position:"absolute",left:"3%",bottom:"6%",width:180,height:180,borderRadius:"50%",
          border:`1px solid ${GOLD}22`,pointerEvents:"none",zIndex:2}}/>

        <div style={{maxWidth:1280,margin:"0 auto",display:"flex",gap:60,alignItems:"center",flexWrap:"wrap",position:"relative",zIndex:3}} className="hflex">
          <div style={{flex:"1 1 460px"}}>
            <div className="lbl fu">Dubai's Trusted Business Consultants</div>
            <h1 className="serif fu fu1 hh" style={{fontSize:64,fontWeight:700,lineHeight:1.1,marginBottom:24}}>
              Where Strategy<br/>Meets <span className="gold-text">Financial</span><br/>Clarity
            </h1>
            <p className="fu fu2" style={{color:MUTED,fontSize:16,lineHeight:1.9,maxWidth:460,marginBottom:36}}>
              Helping 1,000+ entrepreneurs launch, manage, and scale their businesses across the UAE — with full transparency, expert guidance, and zero hidden fees.
            </p>
            <div className="fu fu3" style={{display:"flex",gap:14,flexWrap:"wrap"}}>
              <a href="#/contact" style={{textDecoration:"none"}}>
                <button className="btn-gold">Start Your Business →</button>
              </a>
              <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" style={{textDecoration:"none"}}>
                <button className="btn-ghost">Book Free Consultation</button>
              </a>
            </div>
            <div style={{display:"flex",gap:36,marginTop:52,flexWrap:"wrap"}}>
              {[["1000+","Clients"],["10+","Years"],["99%","Success Rate"]].map(([n,l])=>(
                <div key={l} style={{display:"flex",flexDirection:"column",gap:4,borderLeft:`3px solid ${GOLD}`,paddingLeft:16}}>
                  <span style={{fontFamily:"Cormorant Garamond,serif",fontSize:30,fontWeight:700,color:GOLD}}>{n}</span>
                  <span style={{color:MUTED,fontSize:12,letterSpacing:1}}>{l}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="h900" style={{flex:"0 0 360px"}}>
            <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:8,padding:36,
              boxShadow:"0 20px 60px rgba(0,0,0,0.08)",position:"relative"}}>
              <div style={{position:"absolute",top:0,left:32,right:32,height:3,
                background:`linear-gradient(90deg,${GOLD},${GOLD_LT})`,borderRadius:"0 0 3px 3px"}}/>
              <div className="lbl">Free Consultation</div>
              <h3 className="serif" style={{fontSize:22,marginBottom:24,lineHeight:1.3}}>Get Expert Guidance Today</h3>
              <form onSubmit={submitHeroLead}>
                <input
                  placeholder="Full Name"
                  value={heroLead.name}
                  onChange={e=>setHeroLead({...heroLead,name:e.target.value})}
                  required
                  style={{marginBottom:12}}
                />
                <input
                  placeholder="Phone Number"
                  value={heroLead.phone}
                  onChange={e=>setHeroLead({...heroLead,phone:e.target.value})}
                  required
                  style={{marginBottom:12}}
                />
                <input
                  placeholder="Email Address"
                  value={heroLead.email}
                  onChange={e=>setHeroLead({...heroLead,email:e.target.value})}
                  required
                  style={{marginBottom:12}}
                />
                <textarea
                  placeholder="Briefly describe your business idea..."
                  value={heroLead.idea}
                  onChange={e=>setHeroLead({...heroLead,idea:e.target.value})}
                  required
                  style={{minHeight:80,marginBottom:16}}
                />
                <button type="submit" className="btn-gold" style={{width:"100%",padding:15}}>Submit Enquiry →</button>
              </form>
              <p style={{color:"#9CA3AF",fontSize:11,textAlign:"center",marginTop:10}}>
                <span style={{display:"inline-flex",alignItems:"center",gap:4}}><FiIcon name="check" size={10} color="#9CA3AF"/>Free</span>
                {" · "}
                <span style={{display:"inline-flex",alignItems:"center",gap:4}}><FiIcon name="check" size={10} color="#9CA3AF"/>No obligation</span>
                {" · "}
                <span style={{display:"inline-flex",alignItems:"center",gap:4}}><FiIcon name="check" size={10} color="#9CA3AF"/>Reply within 24h</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* TRUST BAR */}
      <div style={{background:NAVY,padding:"16px 5%"}}>
        <div className="trust-marquee">
          <div className="trust-track">
            {[0,1].map(loop=>(
              <div className="trust-seq" key={loop}>
                {TRUST_ITEMS.map(t=>(
                  <span key={`${loop}-${t.text}`} className="trust-item">
                    <FiIcon name={t.icon} size={12} color="rgba(255,255,255,0.95)"/>
                    {t.text}
                  </span>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ABOUT */}
      <section id="about" style={{padding:"96px 5%",background:WHITE,scrollMarginTop:96}}>
        <div style={{maxWidth:1280,margin:"0 auto",display:"flex",gap:72,alignItems:"center",flexWrap:"wrap"}} className="hflex">
          <div className="about-media-col" style={{flex:"0 0 420px",position:"relative"}}>
            <div className="about-media-main" style={{background:GOLD_BG,borderRadius:8,height:340,display:"flex",alignItems:"center",
              justifyContent:"center",position:"relative",overflow:"hidden"}}>
              <div className="about-media-count" style={{fontFamily:"Cormorant Garamond,serif",fontSize:110,fontWeight:700,
                color:`${GOLD}14`,userSelect:"none",lineHeight:1}}>10+</div>
              <div className="about-media-overlay" style={{position:"absolute",inset:0,display:"flex",flexDirection:"column",
                alignItems:"center",justifyContent:"center",gap:10,
                backgroundImage:`linear-gradient(140deg,rgba(18,20,26,0.52),rgba(18,20,26,0.35)),url(${ABOUT_BG_IMAGE})`,
                backgroundSize:"cover",backgroundPosition:"center"}}>
                <FiIcon name="city" size={46} color={WHITE} style={{filter:"drop-shadow(0 8px 18px rgba(0,0,0,0.28))"}}/>
                <span className="about-media-caption" style={{fontFamily:"Cormorant Garamond,serif",fontSize:18,fontWeight:600,color:WHITE,letterSpacing:.3}}>
                  Dubai Business Experts
                </span>
              </div>
            </div>
            <div className="about-media-badge" style={{position:"absolute",bottom:-20,right:-16,background:WHITE,border:`1px solid ${BORDER}`,
              borderRadius:8,padding:"16px 20px",boxShadow:"0 8px 30px rgba(0,0,0,0.1)",
              display:"flex",gap:14,alignItems:"center"}}>
              <div style={{width:44,height:44,background:GOLD_BG,borderRadius:6,display:"flex",alignItems:"center",
                justifyContent:"center"}}>
                <FiIcon name="award" size={20} color={GOLD}/>
              </div>
              <div>
                <div style={{fontFamily:"Cormorant Garamond,serif",fontWeight:700,fontSize:22,color:GOLD}}>5,000+</div>
                <div style={{fontSize:12,color:MUTED}}>Businesses Launched</div>
              </div>
            </div>
          </div>
          <div style={{flex:1}}>
            <div className="lbl">About LaunchLeap</div>
            <h2 className="serif" style={{fontSize:42,fontWeight:700,lineHeight:1.2,marginBottom:20}}>
              Your End-to-End<br/><span className="gold-text">Business Partner</span> in the UAE
            </h2>
            <div style={{width:50,height:2,background:GOLD,marginBottom:24}}/>
            <p style={{color:MUTED,lineHeight:1.9,marginBottom:20}}>
              Since our inception, LaunchLeap has assisted over 1,000 clients in setting up, managing, and growing their businesses across the UAE. Our strength lies in experienced professionals with deep expertise in business setup, accounting, legal compliance, and visa services.
            </p>
            <p style={{color:MUTED,lineHeight:1.9,marginBottom:32}}>
              We follow a client-first approach — focused on clarity, transparency, and practical solutions that reduce risk and support long-term business growth.
            </p>
            <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
              <a href="#about" style={{textDecoration:"none"}}><button className="btn-gold">Our Story</button></a>
              <a href="#/contact" style={{textDecoration:"none"}}><button className="btn-ghost">Meet the Team</button></a>
            </div>
          </div>
        </div>
      </section>

      {/* VIDEO SECTION */}
      <section id="videos" style={{padding:"96px 5%",background:`linear-gradient(180deg,${LIGHT} 0%,${WHITE} 100%)`,scrollMarginTop:96}}>
        <div style={{maxWidth:1280,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:56}}>
            <div className="lbl" style={{justifyContent:"center"}}>Watch & Learn</div>
            <h2 className="serif" style={{fontSize:44,fontWeight:700,marginBottom:14}}>
              Expert Video <span className="gold-text">Library</span>
            </h2>
            <p style={{color:MUTED,maxWidth:620,margin:"0 auto",lineHeight:1.85}}>
              Explore six practical videos on business setup, licensing, taxation, visa services, and long-term compliance in the UAE.
            </p>
          </div>

          <div className="g3" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:24}}>
            {VIDEO_LIBRARY.map((video)=>(
              <div key={video.title} className="card" style={{overflow:"hidden",background:WHITE}}>
                <div style={{borderBottom:`1px solid ${BORDER}`,background:DARK}}>
                  <iframe
                    width="100%"
                    style={{display:"block",aspectRatio:"16 / 9",border:0}}
                    src={video.src}
                    title={video.title}
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    referrerPolicy="strict-origin-when-cross-origin"
                  />
                </div>
                <div style={{padding:20}}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:12,marginBottom:12}}>
                    <span style={{display:"inline-flex",alignItems:"center",gap:6,background:GOLD_BG,color:GOLD,
                      fontSize:11,fontWeight:600,padding:"4px 10px",borderRadius:999,letterSpacing:.4}}>
                      <FiIcon name="file-video" size={11} color={GOLD}/>
                      {video.category}
                    </span>
                    <span style={{display:"inline-flex",alignItems:"center",gap:6,color:MUTED,fontSize:12}}>
                      <FiIcon name="clock" size={12} color={MUTED}/>
                      {video.duration}
                    </span>
                  </div>
                  <h3 style={{fontSize:16,fontWeight:600,lineHeight:1.5,marginBottom:10,color:DARK}}>{video.title}</h3>
                  <p style={{color:MUTED,fontSize:13,lineHeight:1.75}}>{video.summary}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={{display:"flex",justifyContent:"center",marginTop:34}}>
            <a href="#/contact" style={{textDecoration:"none"}}><button className="btn-gold">Book Free Consultation</button></a>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" style={{padding:"96px 5%",background:LIGHT,scrollMarginTop:96}}>
        <div style={{maxWidth:1280,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:60}}>
            <div className="lbl" style={{justifyContent:"center"}}>What We Offer</div>
            <h2 className="serif" style={{fontSize:44,fontWeight:700,marginBottom:14}}>
              Our <span className="gold-text">Services</span>
            </h2>
            <p style={{color:MUTED,maxWidth:520,margin:"0 auto",lineHeight:1.85}}>
              Comprehensive solutions across the full business lifecycle — from incorporation to ongoing compliance.
            </p>
          </div>
          <div className="g4" style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:20}}>
            {SERVICES.map((s)=>(
              <a key={s.slug} href={`#/services/${s.slug}`} style={{textDecoration:"none",color:"inherit"}}>
                <div className="card" style={{padding:28,cursor:"pointer",height:"100%"}}>
                  <div style={{width:52,height:52,background:GOLD_BG,borderRadius:6,display:"flex",
                    alignItems:"center",justifyContent:"center",marginBottom:18}}>
                    <FiIcon name={s.icon} size={24} color={GOLD}/>
                  </div>
                  <h3 style={{fontSize:15,fontWeight:600,marginBottom:10,color:DARK}}>{s.t}</h3>
                  <p style={{color:MUTED,fontSize:13,lineHeight:1.8}}>{s.d}</p>
                  <div style={{marginTop:18,color:GOLD,fontSize:12,fontWeight:600,letterSpacing:.8}}>Explore Service →</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* STATS */}
      <div ref={statsRef} style={{background:NAVY,padding:"72px 5%"}}>
        <div className="sg" style={{maxWidth:1280,margin:"0 auto",display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:32}}>
          {[
            {v:s1,suf:"+",l:"Clients Served"},
            {v:s2,suf:"+",l:"Years Experience"},
            {v:s3,suf:"%",l:"Success Rate"},
            {v:s4,suf:"+",l:"Businesses Launched"},
          ].map(s=>(
            <div key={s.l} style={{textAlign:"center"}}>
              <div style={{fontFamily:"Cormorant Garamond,serif",fontSize:54,fontWeight:700,color:GOLD_LT,lineHeight:1}}>
                {s.v}{s.suf}
              </div>
              <div style={{color:"rgba(255,255,255,0.6)",fontSize:12,letterSpacing:1.5,marginTop:8,textTransform:"uppercase"}}>{s.l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* WHY US */}
      <section style={{padding:"96px 5%",background:WHITE}}>
        <div style={{maxWidth:1280,margin:"0 auto",display:"flex",gap:72,flexWrap:"wrap",alignItems:"flex-start"}} className="hflex">
          <div style={{flex:"0 0 360px"}}>
            <div className="lbl">Why Choose LaunchLeap</div>
            <h2 className="serif" style={{fontSize:42,fontWeight:700,lineHeight:1.2,marginBottom:16}}>
              8 Reasons Clients<br/><span className="gold-text">Trust Us</span>
            </h2>
            <div style={{width:50,height:2,background:GOLD,marginBottom:24}}/>
            <p style={{color:MUTED,lineHeight:1.9,marginBottom:32}}>
              We combine deep local expertise with a client-first approach to make your business journey smooth, transparent, and rewarding.
            </p>
            <div style={{background:GOLD_BG,border:`1px solid ${GOLD}33`,borderRadius:6,padding:24}}>
              <div style={{fontFamily:"Cormorant Garamond,serif",fontSize:36,fontWeight:700,color:GOLD}}>100%</div>
              <div style={{fontWeight:600,marginBottom:6,fontSize:15}}>Better Results Guaranteed</div>
              <p style={{color:MUTED,fontSize:13,lineHeight:1.8}}>We're not satisfied until you're set up, compliant, and growing confidently.</p>
            </div>
          </div>
          <div className="g2" style={{flex:1,display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
            {WHY.map((w,i)=>(
              <div key={i} className="card" style={{padding:22}}>
                <div style={{marginBottom:10}}>
                  <FiIcon name={w.icon} size={22} color={GOLD}/>
                </div>
                <div style={{fontWeight:600,fontSize:14,marginBottom:6}}>{w.t}</div>
                <div style={{color:MUTED,fontSize:13,lineHeight:1.75}}>{w.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* UAE ADVANTAGE */}
      <section id="why-uae" style={{padding:"96px 5%",background:LIGHT,scrollMarginTop:96}}>
        <div style={{maxWidth:1280,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:60}}>
            <div className="lbl" style={{justifyContent:"center"}}>The UAE Advantage</div>
            <h2 className="serif" style={{fontSize:44,fontWeight:700,marginBottom:14}}>
              Build Your Future <span className="gold-text">in Dubai</span>
            </h2>
            <p style={{color:MUTED,maxWidth:500,margin:"0 auto",lineHeight:1.85}}>
              The UAE offers an unmatched strategic, financial, and operational environment for global entrepreneurs.
            </p>
          </div>
          <div className="g3" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",
            border:`1px solid ${BORDER}`,borderRadius:8,overflow:"hidden",background:WHITE}}>
            {UAE.map((p,i)=>(
              <div key={i} style={{
                padding:36,background:WHITE,position:"relative",overflow:"hidden",
                borderRight: i%3!==2?`1px solid ${BORDER}`:"none",
                borderBottom: i<3?`1px solid ${BORDER}`:"none",
                transition:"all .35s",cursor:"default",
              }}
                onMouseEnter={e=>{e.currentTarget.style.background=GOLD_BG}}
                onMouseLeave={e=>{e.currentTarget.style.background=WHITE}}
              >
                <div style={{position:"absolute",top:16,right:20,fontFamily:"Cormorant Garamond,serif",
                  fontSize:64,fontWeight:700,color:`${GOLD}10`,lineHeight:1}}>{p.n}</div>
                <div style={{width:32,height:2,background:GOLD,marginBottom:20}}/>
                <h3 style={{fontSize:17,fontWeight:600,marginBottom:10,color:DARK}}>{p.t}</h3>
                <p style={{color:MUTED,fontSize:14,lineHeight:1.8}}>{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BLOG */}
      <section id="blog" style={{padding:"96px 5%",background:WHITE,scrollMarginTop:96}}>
        <div style={{maxWidth:1280,margin:"0 auto"}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-end",marginBottom:48,flexWrap:"wrap",gap:16}}>
            <div>
              <div className="lbl">Read Our Blog</div>
              <h2 className="serif" style={{fontSize:40,fontWeight:700}}>Expert <span className="gold-text">Insights</span></h2>
            </div>
            <a href="/#blog" style={{textDecoration:"none"}}><button className="btn-ghost">See All Articles →</button></a>
          </div>
          <div className="g3" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:24}}>
            {BLOGS.map((b)=>(
              <a key={b.slug} href={`#/blog/${b.slug}`} style={{textDecoration:"none",color:"inherit"}}>
                <div className="card" style={{overflow:"hidden",cursor:"pointer",height:"100%"}}>
                  <div style={{height:200,position:"relative",background:`linear-gradient(135deg,${GOLD_BG},${LIGHT2})`}}>
                    <img
                      src={b.image}
                      alt={b.title}
                      loading="lazy"
                      onError={e=>{e.currentTarget.style.display="none";}}
                      style={{width:"100%",height:"100%",objectFit:"cover",display:"block"}}
                    />
                    <div style={{position:"absolute",inset:0,background:"linear-gradient(180deg,rgba(18,20,26,0.06),rgba(18,20,26,0.28))"}}/>
                  </div>
                  <div style={{padding:24}}>
                    <div style={{display:"flex",gap:10,marginBottom:12,alignItems:"center",flexWrap:"wrap"}}>
                      <span style={{background:GOLD_BG,color:GOLD,fontSize:11,fontWeight:600,
                        padding:"3px 10px",borderRadius:2,letterSpacing:.5}}>{b.cat}</span>
                      <span style={{color:MUTED,fontSize:12}}>{b.date}</span>
                      <span style={{color:MUTED,fontSize:12,display:"inline-flex",alignItems:"center",gap:5}}>
                        <FiIcon name="clock" size={11} color={MUTED}/>
                        {b.read}
                      </span>
                    </div>
                    <h3 style={{fontSize:15,fontWeight:500,lineHeight:1.65,marginBottom:10,color:DARK}}>{b.title}</h3>
                    <p style={{color:MUTED,fontSize:13,lineHeight:1.75,marginBottom:14}}>{b.excerpt}</p>
                    <span style={{color:GOLD,fontSize:12,fontWeight:600,letterSpacing:.8}}>Read Full Article →</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* HOME FAQ */}
      <section id="faq-home" style={{padding:"96px 5%",background:LIGHT,scrollMarginTop:96}}>
        <div style={{maxWidth:1080,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:56}}>
            <div className="lbl" style={{justifyContent:"center"}}>FAQ</div>
            <h2 className="serif" style={{fontSize:44,fontWeight:700}}>
              Frequently Asked <span className="gold-text">Questions</span>
            </h2>
            <p style={{color:MUTED,maxWidth:760,margin:"14px auto 0",lineHeight:1.85}}>
              Everything you need to know about UAE company formation, costs, visas, banking, compliance, and how Launch Leap supports your complete journey.
            </p>
          </div>
          <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:8,padding:"0 32px"}}>
            {FAQS.slice(0,5).map((f,i)=><FaqRow key={i} q={f.q} a={f.a}/>)}
          </div>
          <div style={{display:"flex",justifyContent:"center",marginTop:28}}>
            <a href="#/faq" style={{textDecoration:"none"}}>
              <button className="btn-gold">View All FAQs →</button>
            </a>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" style={{padding:"96px 5%",background:WHITE,scrollMarginTop:96}}>
        <div style={{maxWidth:1280,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:60}}>
            <div className="lbl" style={{justifyContent:"center"}}>Contact Us</div>
            <h2 className="serif" style={{fontSize:44,fontWeight:700}}>
              Get Your <span className="gold-text">Free Consultation</span>
            </h2>
            <p style={{color:MUTED,marginTop:14,maxWidth:460,margin:"14px auto 0"}}>
              Planning to start a business in Dubai? Our experts are ready to guide you through every step.
            </p>
          </div>
          <div style={{display:"flex",gap:60,flexWrap:"wrap",alignItems:"flex-start"}} className="hflex contact-layout">
            <div style={{flex:"0 0 300px"}} className="contact-side">
              {CONTACT_ITEMS.map(({icon,label,value})=>(
                <div key={label} style={{display:"flex",gap:16,marginBottom:28,alignItems:"flex-start"}}>
                  <div style={{width:48,height:48,background:GOLD_BG,borderRadius:6,display:"flex",
                    alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <FiIcon name={icon} size={20} color={GOLD}/>
                  </div>
                  <div>
                    <div style={{color:MUTED,fontSize:11,letterSpacing:1.2,textTransform:"uppercase",marginBottom:4}}>{label}</div>
                    <div style={{fontSize:15,fontWeight:500}}>{value}</div>
                  </div>
                </div>
              ))}
              <div style={{background:NAVY,borderRadius:8,padding:28,color:WHITE,marginTop:8}}>
                <div style={{fontFamily:"Cormorant Garamond,serif",fontSize:22,fontWeight:700,marginBottom:10}}>Working Hours</div>
                <div style={{fontSize:14,color:"rgba(255,255,255,0.75)",lineHeight:2}}>
                  Mon – Fri: 9:00 AM – 7:00 PM<br/>
                  Saturday: 10:00 AM – 3:00 PM<br/>
                  Sunday: Closed
                </div>
              </div>
            </div>
            <div style={{flex:1,minWidth:280}} className="contact-form-col">
              {sent?(
                <div className="contact-form-card" style={{background:GOLD_BG,border:`1px solid ${GOLD}55`,borderRadius:8,padding:48,textAlign:"center"}}>
                  <div style={{marginBottom:16}}>
                    <FiIcon name="check-circle" size={52} color={GOLD}/>
                  </div>
                  <h3 className="serif" style={{fontSize:26,marginBottom:10}}>Message Sent!</h3>
                  <p style={{color:MUTED}}>Our team will contact you within 24 hours.</p>
                </div>
              ):(
                <form onSubmit={submit} className="contact-form-card">
                  <div className="f2" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
                    <input placeholder="Your Name *" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} required/>
                    <input placeholder="Phone Number *" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} required/>
                  </div>
                  <input placeholder="Email Address *" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} required style={{marginBottom:16}}/>
                  <input placeholder="Subject *" value={form.subject} onChange={e=>setForm({...form,subject:e.target.value})} required style={{marginBottom:16}}/>
                  <textarea placeholder="Your Message *" value={form.msg} onChange={e=>setForm({...form,msg:e.target.value})} required style={{marginBottom:20}}/>
                  <button type="submit" className="btn-gold" style={{width:"100%",padding:15,fontSize:14}}>Send Message →</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <div style={{background:`linear-gradient(135deg,${GOLD} 0%,${GOLD_LT} 100%)`,padding:"64px 5%",textAlign:"center"}}>
        <h2 className="serif" style={{fontSize:38,fontWeight:700,color:WHITE,marginBottom:12}}>
          Ready to Launch Your Business in Dubai?
        </h2>
        <p style={{color:"rgba(255,255,255,0.85)",marginBottom:28,fontSize:16}}>
          Join 1,000+ entrepreneurs who trusted LaunchLeap with their vision.
        </p>
        <button style={{background:WHITE,color:GOLD,border:"none",padding:"14px 40px",
          fontFamily:"Inter,sans-serif",fontSize:14,fontWeight:700,letterSpacing:.5,
          cursor:"pointer",borderRadius:3,textTransform:"uppercase",transition:"all .3s"}}
          onClick={()=>window.location.hash="/contact"}
          onMouseEnter={e=>{e.currentTarget.style.background=DARK;e.currentTarget.style.color=GOLD_LT}}
          onMouseLeave={e=>{e.currentTarget.style.background=WHITE;e.currentTarget.style.color=GOLD}}
        >Contact Us Now →</button>
      </div>
      </>
      ) : isFaqPage ? (
        <>
      {/* FAQ PAGE */}
      <section id="faq-page" style={{padding:"130px 5% 96px",background:LIGHT,minHeight:"100vh"}}>
        <div style={{maxWidth:1080,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:56}}>
            <div className="lbl" style={{justifyContent:"center"}}>FAQ Page</div>
            <h1 className="serif" style={{fontSize:52,fontWeight:700,lineHeight:1.2}}>
              Frequently Asked <span className="gold-text">Questions</span>
            </h1>
            <p style={{color:MUTED,maxWidth:760,margin:"14px auto 0",lineHeight:1.9}}>
              Find complete answers about UAE company setup, licensing, banking, compliance, visas, and ongoing support.
            </p>
          </div>

          <div style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:8,padding:"0 32px",
            boxShadow:"0 14px 44px rgba(18,20,26,0.08)"}}>
            {FAQS.map((f,i)=><FaqRow key={i} q={f.q} a={f.a}/>)}
          </div>

          <div style={{display:"flex",justifyContent:"center",marginTop:32}}>
            <a href="/" style={{textDecoration:"none"}}>
              <button className="btn-gold">Back to Home →</button>
            </a>
          </div>
        </div>
      </section>
      </>
      ) : isServicePage ? (
        <>
      {/* SERVICE DETAIL PAGE */}
      <section id="service-page" style={{padding:"130px 5% 96px",background:LIGHT,minHeight:"100vh"}}>
        <div style={{maxWidth:1280,margin:"0 auto"}}>
          <a href="/#services" style={{textDecoration:"none",color:GOLD,fontSize:12,fontWeight:600,letterSpacing:1,textTransform:"uppercase"}}>
            Back to Services
          </a>

          <div style={{display:"flex",gap:40,flexWrap:"wrap",alignItems:"stretch",marginTop:16,marginBottom:28}} className="hflex">
            <div style={{flex:"1 1 520px"}}>
              <div className="lbl">Service Details</div>
              <h1 className="serif" style={{fontSize:52,fontWeight:700,lineHeight:1.15,marginBottom:16}}>
                {activeService.t}
              </h1>
              <p style={{color:MUTED,lineHeight:1.95,marginBottom:14}}>
                {activeService.long}
              </p>
              <div style={{display:"inline-flex",alignItems:"center",gap:10,background:GOLD_BG,border:`1px solid ${GOLD}33`,
                borderRadius:999,padding:"8px 14px",color:"#7A5F1C",fontSize:13,fontWeight:500}}>
                <FiIcon name="clock" size={13} color={GOLD}/>
                {activeService.timeline}
              </div>
              <div style={{display:"flex",gap:12,flexWrap:"wrap",marginTop:24}}>
                <a href="#/contact" style={{textDecoration:"none"}}><button className="btn-gold">Start This Service</button></a>
                <a href="/#services" style={{textDecoration:"none"}}><button className="btn-ghost">View All Services</button></a>
              </div>
            </div>

            <div style={{flex:"1 1 420px"}}>
              <div style={{border:`1px solid ${BORDER}`,borderRadius:10,overflow:"hidden",background:WHITE,
                boxShadow:"0 18px 44px rgba(18,20,26,0.12)"}}>
                <img src={activeService.image} alt={activeService.t} className="service-hero-image"/>
              </div>
            </div>
          </div>

          <div className="g2" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:22,marginBottom:22}}>
            <div className="card" style={{padding:28}}>
              <div className="lbl">Included Scope</div>
              <h3 className="serif" style={{fontSize:30,lineHeight:1.2,marginBottom:14}}>What You Get</h3>
              <div style={{display:"grid",gap:12}}>
                {activeService.includes.map((item)=>(
                  <div key={item} style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                    <FiIcon name="check-circle" size={16} color={GOLD} style={{marginTop:2,flexShrink:0}}/>
                    <span style={{color:MUTED,fontSize:14,lineHeight:1.75}}>{item}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="card" style={{padding:28}}>
              <div className="lbl">Value Delivered</div>
              <h3 className="serif" style={{fontSize:30,lineHeight:1.2,marginBottom:14}}>Expected Outcomes</h3>
              <div style={{display:"grid",gap:12}}>
                {activeService.outcomes.map((item)=>(
                  <div key={item} style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                    <FiIcon name="badge-check" size={16} color={GOLD} style={{marginTop:2,flexShrink:0}}/>
                    <span style={{color:MUTED,fontSize:14,lineHeight:1.75}}>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="card" style={{padding:30,marginBottom:24}}>
            <div className="lbl">Execution Plan</div>
            <h3 className="serif" style={{fontSize:34,lineHeight:1.2,marginBottom:16}}>Step-by-Step Process</h3>
            <div className="g2" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:14}}>
              {activeService.process.map((step,idx)=>(
                <div key={step} style={{display:"flex",gap:12,background:LIGHT,border:`1px solid ${BORDER}`,borderRadius:8,padding:14}}>
                  <div style={{width:30,height:30,flexShrink:0,background:GOLD_BG,color:GOLD,borderRadius:999,display:"flex",
                    alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700}}>
                    {String(idx+1).padStart(2,"0")}
                  </div>
                  <p style={{color:MUTED,fontSize:14,lineHeight:1.75}}>{step}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:10}}>
              <h3 className="serif" style={{fontSize:34,fontWeight:700}}>Related Services</h3>
              <a href="/#services" style={{color:GOLD,fontSize:13,fontWeight:600,letterSpacing:.6,textDecoration:"none"}}>Browse All →</a>
            </div>
            <div className="g3" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:18}}>
              {relatedServices.map((s)=>(
                <a key={s.slug} href={`#/services/${s.slug}`} style={{textDecoration:"none",color:"inherit"}}>
                  <div className="card" style={{padding:22,height:"100%"}}>
                    <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:10}}>
                      <FiIcon name={s.icon} size={18} color={GOLD}/>
                      <span style={{fontWeight:600,fontSize:15,color:DARK}}>{s.t}</span>
                    </div>
                    <p style={{color:MUTED,fontSize:13,lineHeight:1.75}}>{s.d}</p>
                    <div style={{marginTop:14,color:GOLD,fontSize:12,fontWeight:600,letterSpacing:.7}}>Open Service Page →</div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
      </>
      ) : isBlogPage ? (
        <>
      {/* BLOG DETAIL PAGE */}
      <section id="blog-page" style={{padding:"130px 5% 96px",background:LIGHT,minHeight:"100vh"}}>
        <div style={{maxWidth:1180,margin:"0 auto"}}>
          <a href="/#blog" style={{textDecoration:"none",color:GOLD,fontSize:12,fontWeight:600,letterSpacing:1,textTransform:"uppercase"}}>
            Back to Blog
          </a>

          <div style={{marginTop:16,marginBottom:20}}>
            <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap",marginBottom:14}}>
              <span style={{background:GOLD_BG,color:GOLD,fontSize:11,fontWeight:600,padding:"4px 12px",borderRadius:999,letterSpacing:.4}}>
                {activeBlog.cat}
              </span>
              <span style={{color:MUTED,fontSize:13}}>{activeBlog.date}</span>
              <span style={{color:MUTED,fontSize:13,display:"inline-flex",alignItems:"center",gap:5}}>
                <FiIcon name="clock" size={12} color={MUTED}/>
                {activeBlog.read}
              </span>
            </div>
            <h1 className="serif" style={{fontSize:52,fontWeight:700,lineHeight:1.15,marginBottom:14}}>
              {activeBlog.title}
            </h1>
            <p style={{color:MUTED,fontSize:16,lineHeight:1.9,maxWidth:980}}>
              {activeBlog.excerpt}
            </p>
          </div>

          <div style={{border:`1px solid ${BORDER}`,borderRadius:10,overflow:"hidden",background:WHITE,
            boxShadow:"0 16px 44px rgba(18,20,26,0.1)",marginBottom:26}}>
            <img src={activeBlog.image} alt={activeBlog.title} className="blog-hero-image"/>
          </div>

          <div className="g2" style={{display:"grid",gridTemplateColumns:"1.2fr .8fr",gap:22,alignItems:"start"}}>
            <div className="card" style={{padding:30}}>
              <div className="lbl">Article Overview</div>
              <p style={{color:MUTED,lineHeight:1.95,marginBottom:18}}>
                {activeBlog.intro}
              </p>
              <div style={{display:"grid",gap:18}}>
                {activeBlog.sections.map((section)=>(
                  <div key={section.h}>
                    <h3 className="serif" style={{fontSize:28,fontWeight:700,lineHeight:1.2,marginBottom:8}}>{section.h}</h3>
                    <p style={{color:MUTED,fontSize:14,lineHeight:1.9}}>{section.p}</p>
                  </div>
                ))}
              </div>
            </div>

            <div style={{display:"grid",gap:18}}>
              <div className="card" style={{padding:24}}>
                <div className="lbl">Key Takeaways</div>
                <div style={{display:"grid",gap:12}}>
                  {activeBlog.highlights.map((item)=>(
                    <div key={item} style={{display:"flex",gap:10,alignItems:"flex-start"}}>
                      <FiIcon name="check-circle" size={16} color={GOLD} style={{marginTop:2,flexShrink:0}}/>
                      <span style={{color:MUTED,fontSize:14,lineHeight:1.75}}>{item}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="card" style={{padding:24}}>
                <div className="lbl">Need Expert Help?</div>
                <h3 className="serif" style={{fontSize:30,lineHeight:1.2,marginBottom:10}}>Plan Your Setup with LaunchLeap</h3>
                <p style={{color:MUTED,fontSize:14,lineHeight:1.8,marginBottom:14}}>
                  Get practical guidance from our consultants and move from planning to execution with complete clarity.
                </p>
                <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
                  <a href="#/contact" style={{textDecoration:"none"}}><button className="btn-gold">Book Consultation</button></a>
                  <a href="/#services" style={{textDecoration:"none"}}><button className="btn-ghost">Our Services</button></a>
                </div>
              </div>
            </div>
          </div>

          <div style={{marginTop:28}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:10}}>
              <h3 className="serif" style={{fontSize:34,fontWeight:700}}>Related Articles</h3>
              <a href="/#blog" style={{color:GOLD,fontSize:13,fontWeight:600,letterSpacing:.6,textDecoration:"none"}}>View All →</a>
            </div>
            <div className="g3" style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:18}}>
              {relatedBlogs.map((b)=>(
                <a key={b.slug} href={`#/blog/${b.slug}`} style={{textDecoration:"none",color:"inherit"}}>
                  <div className="card" style={{overflow:"hidden",height:"100%"}}>
                    <img src={b.image} alt={b.title} className="blog-related-image"/>
                    <div style={{padding:18}}>
                      <div style={{display:"flex",gap:8,alignItems:"center",marginBottom:8,flexWrap:"wrap"}}>
                        <span style={{background:GOLD_BG,color:GOLD,fontSize:10,fontWeight:600,padding:"3px 8px",borderRadius:999}}>{b.cat}</span>
                        <span style={{color:MUTED,fontSize:11}}>{b.read}</span>
                      </div>
                      <h4 style={{fontSize:14,fontWeight:600,lineHeight:1.6,color:DARK,marginBottom:8}}>{b.title}</h4>
                      <p style={{color:MUTED,fontSize:12,lineHeight:1.75}}>{b.excerpt}</p>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
      </>
      ) : isContactPage ? (
        <>
      {/* CONTACT PAGE */}
      <section id="contact-page" style={{padding:"130px 5% 96px",background:LIGHT,minHeight:"100vh"}}>
        <div style={{maxWidth:1280,margin:"0 auto"}}>
          <div style={{textAlign:"center",marginBottom:60}}>
            <div className="lbl" style={{justifyContent:"center"}}>Contact Page</div>
            <h1 className="serif" style={{fontSize:52,fontWeight:700,lineHeight:1.2}}>
              Let Us Build Your <span className="gold-text">UAE Business</span>
            </h1>
            <p style={{color:MUTED,maxWidth:700,margin:"14px auto 0",lineHeight:1.9}}>
              Share your goals and get expert guidance on company setup, visa planning, banking support, and compliance.
            </p>
          </div>

          <div style={{display:"flex",gap:60,flexWrap:"wrap",alignItems:"flex-start"}} className="hflex contact-layout">
            <div style={{flex:"0 0 320px"}} className="contact-side">
              {CONTACT_ITEMS.map(({icon,label,value})=>(
                <div key={label} style={{display:"flex",gap:16,marginBottom:28,alignItems:"flex-start"}}>
                  <div style={{width:50,height:50,background:GOLD_BG,borderRadius:6,display:"flex",
                    alignItems:"center",justifyContent:"center",flexShrink:0}}>
                    <FiIcon name={icon} size={20} color={GOLD}/>
                  </div>
                  <div>
                    <div style={{color:MUTED,fontSize:11,letterSpacing:1.2,textTransform:"uppercase",marginBottom:4}}>{label}</div>
                    <div style={{fontSize:15,fontWeight:500}}>{value}</div>
                  </div>
                </div>
              ))}
              <div style={{background:NAVY,borderRadius:8,padding:28,color:WHITE,marginTop:8}}>
                <div style={{fontFamily:"Cormorant Garamond,serif",fontSize:22,fontWeight:700,marginBottom:10}}>Working Hours</div>
                <div style={{fontSize:14,color:"rgba(255,255,255,0.75)",lineHeight:2}}>
                  Mon – Fri: 9:00 AM – 7:00 PM<br/>
                  Saturday: 10:00 AM – 3:00 PM<br/>
                  Sunday: Closed
                </div>
              </div>
            </div>

            <div style={{flex:1,minWidth:300}} className="contact-form-col">
              <div className="contact-form-card" style={{background:WHITE,border:`1px solid ${BORDER}`,borderRadius:10,padding:30,boxShadow:"0 14px 44px rgba(18,20,26,0.08)"}}>
                {sent?(
                  <div style={{background:GOLD_BG,border:`1px solid ${GOLD}55`,borderRadius:8,padding:48,textAlign:"center"}}>
                    <div style={{marginBottom:16}}>
                      <FiIcon name="check-circle" size={52} color={GOLD}/>
                    </div>
                    <h3 className="serif" style={{fontSize:26,marginBottom:10}}>Message Sent!</h3>
                    <p style={{color:MUTED}}>Our team will contact you within 24 hours.</p>
                  </div>
                ):(
                  <form onSubmit={submit}>
                    <div className="f2" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
                      <input placeholder="Your Name *" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} required/>
                      <input placeholder="Phone Number *" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} required/>
                    </div>
                    <input placeholder="Email Address *" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} required style={{marginBottom:16}}/>
                    <input placeholder="Subject *" value={form.subject} onChange={e=>setForm({...form,subject:e.target.value})} required style={{marginBottom:16}}/>
                    <textarea placeholder="Your Message *" value={form.msg} onChange={e=>setForm({...form,msg:e.target.value})} required style={{marginBottom:20}}/>
                    <button type="submit" className="btn-gold" style={{width:"100%",padding:15,fontSize:14}}>Send Message →</button>
                  </form>
                )}
              </div>
              <div className="contact-page-actions" style={{display:"flex",gap:12,flexWrap:"wrap",marginTop:18}}>
                <a href="/" style={{textDecoration:"none"}}><button className="btn-ghost">Back to Home</button></a>
                <a href="#/faq" style={{textDecoration:"none"}}><button className="btn-gold">Go to FAQ Page</button></a>
              </div>
            </div>
          </div>
        </div>
      </section>
      </>
      ) : isNotFoundPage ? (
        <>
      {/* NOT FOUND */}
      <section style={{padding:"130px 5% 96px",background:LIGHT,minHeight:"100vh"}}>
        <div style={{maxWidth:820,margin:"0 auto",textAlign:"center"}}>
          <div className="lbl" style={{justifyContent:"center"}}>Page Not Found</div>
          <h1 className="serif" style={{fontSize:52,fontWeight:700,lineHeight:1.2,marginBottom:14}}>
            This page does not exist.
          </h1>
          <p style={{color:MUTED,lineHeight:1.9,maxWidth:620,margin:"0 auto 24px"}}>
            Please go back to the homepage and continue exploring our services and resources.
          </p>
          <a href="/" style={{textDecoration:"none"}}>
            <button className="btn-gold">Go to Home</button>
          </a>
        </div>
      </section>
      </>
      ) : null}

      <a
        href={WHATSAPP_LINK}
        target="_blank"
        rel="noreferrer"
        className="whatsapp-btn"
        aria-label="Open WhatsApp chat with LaunchLeap"
      >
        <WhatsAppIcon size={28}/>
      </a>

      {/* FOOTER */}
      <footer style={{background:DARK,color:WHITE,padding:"64px 5% 28px"}}>
        <div style={{maxWidth:1280,margin:"0 auto"}}>
          <div className="fg" style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:40,marginBottom:48}}>
            <div>
              <a href="/" style={{display:"inline-flex",alignItems:"center",textDecoration:"none",marginBottom:16}}>
                <img src={BRAND_LOGO_IMAGE} alt="LaunchLeap" className="brand-logo-footer"/>
              </a>
              <p style={{color:"rgba(255,255,255,0.45)",fontSize:14,lineHeight:1.85,maxWidth:270}}>
                Your trusted partner for business setup and growth in the UAE — from licensing to long-term compliance.
              </p>
              <div style={{marginTop:24}}>
                <p style={{color:"rgba(255,255,255,0.35)",fontSize:12,marginBottom:10,letterSpacing:1}}>NEWSLETTER</p>
                <form onSubmit={submitNewsletter} style={{display:"flex"}}>
                  <input
                    placeholder="Enter email"
                    type="email"
                    value={newsletterEmail}
                    onChange={e=>setNewsletterEmail(e.target.value)}
                    required
                    style={{background:"rgba(255,255,255,0.07)",
                      border:"1px solid rgba(255,255,255,0.12)",color:WHITE,borderRadius:"3px 0 0 3px",flex:1}}
                  />
                  <button type="submit" className="btn-gold" style={{borderRadius:"0 3px 3px 0",whiteSpace:"nowrap",padding:"0 16px"}}>Go</button>
                </form>
              </div>
            </div>
            <div>
              <h4 style={{fontSize:12,fontWeight:600,letterSpacing:2,textTransform:"uppercase",color:GOLD_LT,marginBottom:18}}>Quick Links</h4>
              {FOOTER_QUICK_LINKS.map(({label,href})=>(
                <a key={label} href={href} style={{
                  color:"rgba(255,255,255,0.4)",
                  fontSize:14,
                  marginBottom:10,
                  cursor:"pointer",
                  transition:"color .2s",
                  display:"block",
                  textDecoration:"none",
                }}
                  onMouseEnter={e=>e.currentTarget.style.color=WHITE}
                  onMouseLeave={e=>e.currentTarget.style.color="rgba(255,255,255,0.4)"}
                >{label}</a>
              ))}
            </div>
            <div>
              <h4 style={{fontSize:12,fontWeight:600,letterSpacing:2,textTransform:"uppercase",color:GOLD_LT,marginBottom:18}}>Services</h4>
              {FOOTER_SERVICE_LINKS.map(({label,href})=>(
                <a key={label} href={href} style={{
                  color:"rgba(255,255,255,0.4)",
                  fontSize:14,
                  marginBottom:10,
                  cursor:"pointer",
                  transition:"color .2s",
                  display:"block",
                  textDecoration:"none",
                }}
                  onMouseEnter={e=>e.currentTarget.style.color=WHITE}
                  onMouseLeave={e=>e.currentTarget.style.color="rgba(255,255,255,0.4)"}
                >{label}</a>
              ))}
            </div>
            <div>
              <h4 style={{fontSize:12,fontWeight:600,letterSpacing:2,textTransform:"uppercase",color:GOLD_LT,marginBottom:18}}>Get in Touch</h4>
              {["Dubai, UAE","info@launchleap.com",BUSINESS_PHONE,"Mon–Fri 9AM–7PM"].map((it)=>(
                <div key={it} style={{color:"rgba(255,255,255,0.4)",fontSize:14,marginBottom:10}}>
                  {it}
                </div>
              ))}
              <div style={{marginTop:14}}>
                <h4 style={{fontSize:12,fontWeight:600,letterSpacing:2,textTransform:"uppercase",color:GOLD_LT,marginBottom:10}}>Follow Us</h4>
                <div className="footer-socials">
                  {SOCIAL_LINKS.map(({id,label,href})=>(
                    <a
                      key={label}
                      href={href}
                      target="_blank"
                      rel="noreferrer"
                      aria-label={`Visit LaunchLeap on ${label}`}
                      title={label}
                      className="footer-social-link"
                    >
                      <SocialIcon id={id} size={14} color="currentColor"/>
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div style={{borderTop:"1px solid rgba(255,255,255,0.08)",paddingTop:22,display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:12}}>
            <p style={{color:"rgba(255,255,255,0.25)",fontSize:13}}>© 2026 LaunchLeap. All Rights Reserved.</p>
            <div style={{display:"flex",gap:20}}>
              {["Terms & Conditions","Privacy Policy"].map(l=>(
                <span key={l} style={{color:"rgba(255,255,255,0.25)",fontSize:13,cursor:"pointer"}}>{l}</span>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
